/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-nested-ternary */
import * as Yup from 'yup';
import { OBLIGATION_REGEX, CONTACT_NUMBER_REGEX, NAME_FIELDS_NEW_REGEX, FIELDS_WITH_SEPCIFI_CHARS, VEHICLE_REGISTRATION_REGEX } from '@services/ValidationRules';
import { iAddress, iContact, iFormMetaData, iAttachments, iFVSCheckboxAll, iObligation, iValue, iSummary, iSummaryField } from '@interfaces/interfaces';
import { ProgressStep, FormType } from '@constants';
import { reverseTrueOrFalseSubmission } from '@utils';
import { FormikValues, getIn } from 'formik';
import { fvsInfoDisplayObject } from '@services/FormFieldConfig';

import {
  INVALID_OBLIGATION_NUMBER,
  INVALID_NUMERIC_FORMAT,
  INVALID_YESNO_FORMAT,
  INVALID_NAME_FORMAT,
  EMPTY_DATE,
  EMPTY_CHECKBOX,
  INVALID_FUTURE_DATE,
  INVALID_PHONE_NUMBER_LENGTH,
  INVALID_PHONE_NUMBER,
  INVALID_VEHICLE_REGISTRATION_NUMBER,
  INVALID_EMAIL,
  MISSING_DECLARATION_AGREEMENT,
  INVALID_FILE_SIZE,
  FILE_UPLOAD_FAIL,
  INVALID_LICENCE_FORMAT,
  MISSING_APPLICATION_LODGING_AGREEMENT,
  INVALID_MOBILE_NUMBER_FORMAT,
  FIELDS_WITH_SEPCIFI_CHARS_MSG,
  INVALID_PHONE_NUMBER_LENGTH_15,
} from './ErrorMessages';
import keys from './PageValidationKeys';

const joinAddressFields = (entry: string[]) => {
  if (entry[0] === 'Address' || entry[0] === 'SearchText') return null;
  if (entry[0] === 'Country') return entry[1];
  return entry[1];
};
const today = new Date();
const displayFileDetails = (attachment: iAttachments) => {
  if (attachment.FileName !== '' && attachment.FileDescription !== '') {
    return `${attachment.FileName} : ${attachment.FileDescription}`;
  }
  if (attachment.FileName !== '' && attachment.FileDescription === '') {
    return `${attachment.FileName}`;
  }
  return '';
};
const { riskAndSupportDetails, backgroundAndIdentityDetails, likelyPossibilities, paymentArrangements } = fvsInfoDisplayObject.pages;
const listUnregisteredFines = (values: iExtensionFormValues, unregisteredFinesArray: iValue[]) =>
  unregisteredFinesArray.map(
    (fine, index) =>
      `Enforcement agency: ${getIn(values, `AgencyNames.${index}.value`) ? getIn(values, `AgencyNames.${index}.value`) : 'n/a'}, Infringement notice number: ${
        getIn(values, `InfringementNums.${index}.value`) ? getIn(values, `InfringementNums.${index}.value`) : 'n/a'
      }, Alleged offence: ${getIn(values, `AOffence.${index}.value`) ? getIn(values, `AOffence.${index}.value`) : 'n/a'}, Date of alleged offence: ${
        getIn(values, `DAOffence.${index}.value`) ? new Date(getIn(values, `DAOffence.${index}.value`)).toLocaleDateString('en-AU', { timeZone: 'Australia/Melbourne' }) : 'n/a'
      }`,
  );
export interface iPartialFormData {
  a: string;
  // submitted
  submitted: boolean;
  // Extension Step1 Field
  OBLIGATION_NUMBER: string;
  // Extension Step2 Fields
  OFFENCE_DATE: Date | null;
  HEARING_DATE: Date | null;
  VEHICLE_REGISTRATION: string;
  DRIVER_LICENCE: string;
  isEOIW: boolean;
  isInitialOrReminderStatus: boolean;
  IsCompany: boolean;
  DDD: boolean;
  ESI: boolean;
  MarineOffence: boolean;
  IsESIorDDD: boolean;

  // Extension step 4 fields
  SaveYesNo: string;
  SaveOptions: string;
  saveEmail: string;
  saveMobile: string;

  // Step 5
  DateToPay: Date | null;
  // Extension step 6 fields
  TitleMrMrsMsMissOther: string;
  GivenNames: string;
  FamilyName: string;
  DOB: Date | null;
  StatecountryOfIssue: string;
  LicenceState: string;
  NoDriverLicence: boolean;
  HasDifferentResidentialAddress: string;
  ExtensionResidentialAddress: iAddress;
  ExtensionPostalAddress: iAddress;
  Email: string;
  EMAIL_TO: string;
  NoEmail: boolean;
  receiveDocs: string | null;
  ExtensionContactNumber: iContact;
  EmailWarning: string;
  ExtensionContactNumberWarning: string;
  ExtensionContactNumberWarningSecond: string;
  // Extension Step 7
  ExceptionalCircumstances: string;
  OtherSupportingAttachments: iAttachments[];
  DetailsForCircumstances: string;
  // Extension Step 9
  InfringementNoticeNumber: string;
  SelectedObligationsStep9: iFVSCheckboxAll[];
  ObligationStatus: string;
  TicketType: string;
  Status: string;
  OffenceCode: string;
  AdditionalFinesToInclude: string;
  // Extension Step 12
  SupportingAttachments: iAttachments[];
}

interface iPartialFormObligations {
  ID: number;
  ObligationNO: string;
  IsPrimary: boolean;
}
export interface iCommonExtensionFormValues {
  [key: string]:
    | string
    | number
    | boolean
    | iPartialFormObligations[]
    | iObligation
    | iPartialFormData
    | iObligation[]
    | iAttachments[]
    | iValue[]
    | iFVSCheckboxAll[]
    | string[]
    | Date
    | null
    | iAddress
    | iContact;
  // submitted
  submitted: boolean;
  // Extension Step1 Field
  OBLIGATION_NUMBER: string;
  // Extension Step2 Fields
  OFFENCE_DATE: Date | null;
  HEARING_DATE: Date | null;
  VEHICLE_REGISTRATION: string;
  isEOIW: boolean;
  isInitialOrReminderStatus: boolean;
  IsCompany: boolean;
  DDD: boolean;
  ESI: boolean;
  MarineOffence: boolean;
  IsESIorDDD: boolean;
  // Step 2 and 6
  DRIVER_LICENCE: string;
  DOB: Date | null;
  // Extension step 4 fields
  SaveYesNo: string;
  SaveOptions: string;
  saveEmail: string;
  saveMobile: string;
  // Extension partial form ID
  ID: string;
  PartialFormID: string;
  FormData: iPartialFormData;
  Obligations: iPartialFormObligations[];
}

export interface iExtensionFormValues extends iCommonExtensionFormValues {
  // Extension Step4 response
  InfringementNoticeNumber: string;
  Attachments: string[];
  DebtorID: number;
  FormTypeID: number;
  IsSubscribedEM: boolean;
  IsSubscribedSMS: boolean;
  EMRemeinderSent: boolean;
  SMSRemeinderSent: boolean;
  CreateDate: string;
  ExpiryDate: string;
  // GetObligationOptions response
  DebtorType: string;
  // CreateReceiptNumber response
  submissionNo: string;
  // Declaration
  declaration: boolean;
  // Extension Step5 Fields
  DateToPay: Date | null;
  // Extension step 6 fields
  TitleMrMrsMsMissOther: string;
  GivenNames: string;
  FamilyName: string;
  DOB: Date | null;
  StatecountryOfIssue: string;
  LicenceState: string;
  NoDriverLicence: boolean;
  HasDifferentResidentialAddress: string;
  ExtensionResidentialAddress: iAddress;
  ExtensionPostalAddress: iAddress;
  Email: string;
  EMAIL_TO: string; // email copy
  receiveDocs: string | null;
  NoEmail: boolean;
  ExtensionContactNumber: iContact;
  EmailWarning: string;
  ExtensionContactNumberWarning: string;
  ExtensionContactNumberWarningSecond: string;
  // Extension Step 7
  ExceptionalCircumstances: string;
  OtherSupportingAttachments: iAttachments[];
  DetailsForCircumstances: string;
  // Extension Step 9 and 18 fields
  SelectedObligationsStep9: iFVSCheckboxAll[];
  SelectedObligations: string[];
  SelectedObNums: string;
  AuthorisedObligation: iObligation;
  EligibleObligations: iObligation[];
  ObligationStatus: string;
  AdditionalFinesToInclude: string;
  TicketType: string;
  Status: string;
  OffenceCode: string;
  // Extension Step 12 and 21 fields
  SupportingAttachments: iAttachments[];
  SupportingFilesProvider: string;
  SupportingFilesDescription: string;
  ReportNameField: string;
  ReportNameFieldErrorHandle: boolean;
  ReportUploadFileSectionError: string;
  // Extension Step 13 and 22 fields
  OtherSupportingDocNameField: string;
  OtherSupportingFilesProvider: string;
  OtherSupportingFilesDescription: string;
  OtherReportNameFieldErrorHandle: boolean;
  // File upload failed
  OtherReportNameFileUploadErrorHandle: boolean;
  submissionError: string;
}

export interface iSubmitExtensionFormValues extends iCommonExtensionFormValues {
  YourObligationNumber: string;
  OBLIGATION_NUMBER: string;
  IdentifyingReference: string;
  InfringementNoticeNumber: string;

  // Extension Step5 Fields
  // Date to pay
  DDThree: string;
  MMThree: string;
  YYYYThree: string;
  // step 6
  TitleMrMrsMsOther: string;
  FirstOrGivenNames: string;
  LastNameOrFamilyName: string;
  DD: string;
  MM: string;
  YYYY: string;
  DriverLicenceNumber: string;
  StateOrCountryOfIssue: string;
  VehicleRegistrationIfProvided: string;
  // Residential Address
  LineOne: string;
  LineTwo: string;
  Suburb: string;
  State: string;
  Postcode: string;
  Country: string;
  // Postal address
  LineOneTwo: string;
  LineTwoTwo: string;
  SuburbTwo: string;
  StateTwo: string;
  PostcodeTwo: string;
  CountryTwo: string;
  ContactNumber: string;
  NumberType: string;
  SecondaryContactNumber: string;
  NumberTypeTwo: string;
  YourEmailAddressOptional: string;
  DocumentElectronically: string;
  // otherObligationsAuth.length > 0 && otherObligationsAuth.length <= 3 ? session.obligation.Number +" ;"+ otherObligationsAuth.join(" ;") : otherObligationsAuth.length > 3 ? "Refer to attachment" : session.obligation.Number
  ObligationNumberCaseNumberOrWarrantNumber: string;
  // circumstances.exceptional
  YesOrNoTwo: string;
  // circumstances.details
  ProvideDetailsForAnyCircumstancesYouWouldLikeToBeConsideredForInThisApplication: string;
  NumberOfAttachments: string;
  ApplicantsSignature: string;
  // now time submit time
  DdTwo: string;
  MmTwo: string;
  YyyyTwo: string;
  EMAIL_TO: string;
  // otherObligationsAuth.length > 3 ? session.obligation.Number +"; "+otherObligationsAuth.join("; ") : "",
  // additonal ob pdf page
  OBLIGATIONS_TO_INCLUDE: string;
  // totalAttachments.join("|"),
  ATTACHMENTS: string;
  //
  FooterSubmissionNo1: string;
  FooterFormType1: string;
  FooterObligationNo1: string;
  FooterSubmittedTime1: string;

  FooterSubmissionNo2: string;
  FooterFormType2: string;
  FooterObligationNo2: string;
  FooterSubmittedTime2: string;

  FooterSubmissionNo3: string;
  FooterFormType3: string;
  FooterObligationNo3: string;
  FooterSubmittedTime3: string;

  FooterSubmissionNo4: string;
  FooterFormType4: string;
  FooterObligationNo4: string;
  FooterSubmittedTime4: string;

  FooterSubmissionNo5: string;
  FooterFormType5: string;
  FooterObligationNo5: string;
  FooterSubmittedTime5: string;

  FooterSubmissionNo6: string;
  FooterFormType6: string;
  FooterObligationNo6: string;
  FooterSubmittedTime6: string;

  FooterSubmissionNo7: string;
  FooterFormType7: string;
  FooterObligationNo7: string;
  FooterSubmittedTime7: string;
}

export const defaultForm = (): iExtensionFormValues => {
  const defaultValues: iExtensionFormValues = {
    // iCommonValues
    // submitted
    submitted: false,
    PartialFormID: '',
    OBLIGATION_NUMBER: '',
    InfringementNoticeNumber: '',
    // Extension Step2 Fields
    OFFENCE_DATE: null,
    HEARING_DATE: null,
    DRIVER_LICENCE: '',
    VEHICLE_REGISTRATION: '',
    isEOIW: false,
    isInitialOrReminderStatus: false,
    IsCompany: false,
    DDD: false,
    ESI: false,
    MarineOffence: false,
    IsESIorDDD: false,
    // Extension step 4 fields
    SaveYesNo: '',
    SaveOptions: '',
    saveEmail: '',
    saveMobile: '',
    // Extension Step 5 Field
    DateToPay: null,
    // Extension Step 6 fields
    TitleMrMrsMsMissOther: '',
    FamilyName: '',
    GivenNames: '',
    DOB: null,
    LicenceState: '',
    NoDriverLicence: false,
    StatecountryOfIssue: 'Australia',
    HasDifferentResidentialAddress: '',
    ExtensionResidentialAddress: {
      SearchText: '',
      Address: '',
      LineOne: '',
      LineTwo: '',
      Suburb: '',
      State: '',
      Postcode: '',
      Country: 'Australia',
    },
    ExtensionPostalAddress: {
      SearchText: '',
      Address: '',
      LineOne: '',
      LineTwo: '',
      Suburb: '',
      State: '',
      Postcode: '',
      Country: 'Australia',
    },
    Email: '',
    EMAIL_TO: '',
    NoEmail: false,
    receiveDocs: '',
    ExtensionContactNumber: {
      ContactNumber: '',
      NumberType: '',
      SecondaryContactNumber: '',
      SecondaryNumberType: '',
    },
    EmailWarning: '',
    ExtensionContactNumberWarning: '',
    ExtensionContactNumberWarningSecond: '',
    // Extension Step 7 fields
    ExceptionalCircumstances: '',
    OtherSupportingDocNameField: '',
    OtherSupportingAttachments: [],
    OtherSupportingFilesProvider: '',
    OtherSupportingFilesDescription: '',
    OtherReportNameFieldErrorHandle: false,
    DetailsForCircumstances: '',
    SupportingAttachments: [],
    SupportingFilesProvider: '',
    SupportingFilesDescription: '',
    ReportNameField: '',
    ReportNameFieldErrorHandle: false,
    ReportUploadFileSectionError: '',
    // GetObligationOptions response
    DebtorType: '',
    Attachments: [],
    DebtorID: 0,
    FormTypeID: 2,
    // CreateReceiptNumber response
    submissionNo: '',
    IsSubscribedEM: false,
    IsSubscribedSMS: false,
    EMRemeinderSent: false,
    SMSRemeinderSent: false,
    CreateDate: '',
    ExpiryDate: '',
    // Extension Step 9
    SelectedObligationsStep9: [],
    ObligationStatus: '',
    TicketType: '',
    Status: '',
    OffenceCode: '',
    AdditionalFinesToInclude: '',
    AdditionalFinesType: '',
    SelectedObligations: [],

    // addtional ob pdf page
    OBLIGATIONS_TO_INCLUDE: '',
    // Extension Step 9
    declaration: false,
    SelectedObNums: '',
    AuthorisedObligation: {} as iObligation,
    EligibleObligations: [],

    // File upload failed
    OtherReportNameFileUploadErrorHandle: false,

    submissionError: '',
    // Extension Partial Form data
    ID: '',
    Obligations: [],
    FormData: {
      a: '',
      submitted: false,
      OBLIGATION_NUMBER: '',
      // Extension Step2 Fields
      OFFENCE_DATE: null,
      HEARING_DATE: null,
      VEHICLE_REGISTRATION: '',
      DRIVER_LICENCE: '',
      isEOIW: false,
      isInitialOrReminderStatus: false,
      IsCompany: false,
      DDD: false,
      ESI: false,
      MarineOffence: false,
      IsESIorDDD: false,

      // Extension step 4 fields
      SaveYesNo: '',
      SaveOptions: '',
      saveEmail: '',
      saveMobile: '',
      // Extension Step 5 Field
      DateToPay: null,
      // Extension Step 6 fields
      TitleMrMrsMsMissOther: '',
      FamilyName: '',
      GivenNames: '',
      DOB: null,
      LicenceState: '',
      NoDriverLicence: false,
      StatecountryOfIssue: 'Australia',
      AdditionalFinesToInclude: '',
      HasDifferentResidentialAddress: '',
      ExtensionResidentialAddress: {
        SearchText: '',
        Address: '',
        LineOne: '',
        LineTwo: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      },
      ExtensionPostalAddress: {
        SearchText: '',
        Address: '',
        LineOne: '',
        LineTwo: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      },
      Email: '',
      EMAIL_TO: '',
      NoEmail: false,
      receiveDocs: '',
      ExtensionContactNumber: {
        ContactNumber: '',
        NumberType: '',
        SecondaryContactNumber: '',
        SecondaryNumberType: '',
      },
      EmailWarning: '',
      ExtensionContactNumberWarning: '',
      ExtensionContactNumberWarningSecond: '',
      // Extension Step 7 fields
      ExceptionalCircumstances: '',
      OtherSupportingAttachments: [],
      DetailsForCircumstances: '',
      // Extension Step 9
      InfringementNoticeNumber: '',
      SelectedObligationsStep9: [],
      ObligationStatus: '',
      TicketType: '',
      Status: '',
      OffenceCode: '',
      // Extension Step 12
      SupportingAttachments: [],
    },
  };
  return defaultValues;
};

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const getReceiptPayload = (formValues: any): string => `{
    "ID": "",
    "Receipt": "",
    "Obligations": [
        {
            "ID": "",
            "ObligationNO": "${formValues.OBLIGATION_NUMBER}",
            "IsPrimary": "true",
            "ReceptNumberId": ""
        }
    ],
    "SubmittedDate": "",
    "FormTypeId": 2
  }`;

export const getSubmissionPayload = (formValues: iExtensionFormValues, submissionNumber: string): iSubmitExtensionFormValues => {
  const submitFormValues = formValues;
  const now = new Date();
  const MONTH = (`0${now.getMonth() + 1}`).slice(-2);
  const DATE = (`0${now.getDate()}`).slice(-2);
  const YEAR = now.getFullYear();
  const MINUTE = (now.getMinutes() < 10 ? '0' : '') + now.getMinutes();
  const SUBMITTED_TIME = `${now.getHours()}:${MINUTE} ${DATE}/${MONTH}/${YEAR}`;
  const FORM_TYPE = 'Extension';
  // step 10
  const selectedObsArray = formValues.SelectedObNums.split(', ');
  const joinedBySemiccolon = selectedObsArray.join(' ;');
  const selectedObligationsSelfInclude =
    selectedObsArray.length >= 3
      ? 'Refer to attachment'
      : formValues.SelectedObNums.length !== 0
      ? `${joinedBySemiccolon} ;${formValues.AuthorisedObligation?.Number}`
      : formValues.AuthorisedObligation?.Number;

  const additonalPdfWithObligations = selectedObsArray.length >= 3 ? `${joinedBySemiccolon} ;${formValues.AuthorisedObligation?.Number}` : '';
  // step 12, 13 number of attachments
  const totalNumberOfAttachments = formValues.SupportingAttachments?.length + formValues.OtherSupportingAttachments?.length;
  const descriptionOfAttachmentsArray = [
    ...(formValues.OtherSupportingAttachments || []),
  ];
  let descriptionOfAttachments = '';
  let remoteAttachmentNames = '';
  if (descriptionOfAttachmentsArray) {
    descriptionOfAttachmentsArray.forEach((v) => {
      if (v.FileDescription || v.FileProvider) {
        descriptionOfAttachments += `${v.FileProvider ? v.FileProvider : ''}${v.FileProvider && v.FileDescription ? ' - ' : ''}${v.FileDescription ? v.FileDescription : ''}; `;
      }
      if (v.RemoteFileName) {
        remoteAttachmentNames += `${formValues.OBLIGATION_NUMBER}/${v.RemoteFileName}/${v.RemoteFileName}|`;
      }
    });
  }
  const submitObject: iSubmitExtensionFormValues = {
    ...(submitFormValues as iCommonExtensionFormValues),

    YourObligationNumber: formValues.OBLIGATION_NUMBER,
    InfringementNoticeNumber: formValues.InfringementNoticeNumber,
    OBLIGATION_NUMBER: formValues.OBLIGATION_NUMBER,
    IdentifyingReference: formValues.OBLIGATION_NUMBER,
    // step 5
    DD: formValues.DOB ? (`0${formValues.DOB.getDate()}`).slice(-2) : '',
    MM: formValues.DOB ? (`0${formValues.DOB.getMonth() + 1}`).slice(-2) : '',
    YYYY: formValues.DOB ? formValues.DOB.getFullYear().toString() : '',
    // step 6
    TitleMrMrsMsOther: formValues.TitleMrMrsMsMissOther,
    LastNameOrFamilyName: formValues.FamilyName,
    FirstOrGivenNames: formValues.GivenNames,
    DateOfBirth: formValues.DOB ? `${(`0${formValues.DOB.getDate()}`).slice(-2)}/${(`0${formValues.DOB.getMonth() + 1}`).slice(-2)}/${formValues.DOB?.getFullYear()}` : '',
    DriverLicenceNumber: formValues.NoDriverLicence ? '' : formValues.DRIVER_LICENCE,
    StateOrCountryOfIssue: formValues.NoDriverLicence ? '' : formValues.StatecountryOfIssue === 'Australia' ? formValues.LicenceState : formValues.StatecountryOfIssue,
    CurrentDriversLicense: formValues.NoDriverLicence ? 'true' : false, // pending
    VehicleRegistrationIfProvided: formValues.VEHICLE_REGISTRATION,
    // residential address
    State: formValues.HasDifferentResidentialAddress === 'true' ? formValues.ExtensionResidentialAddress.State : formValues.ExtensionPostalAddress.State,
    Suburb: formValues.HasDifferentResidentialAddress === 'true' ? formValues.ExtensionResidentialAddress.Suburb : formValues.ExtensionPostalAddress.Suburb,
    LineOne: formValues.HasDifferentResidentialAddress === 'true' ? formValues.ExtensionResidentialAddress.LineOne : formValues.ExtensionPostalAddress.LineOne,
    LineTwo: formValues.HasDifferentResidentialAddress === 'true' ? formValues.ExtensionResidentialAddress.LineTwo : formValues.ExtensionPostalAddress.LineTwo,
    Postcode: formValues.HasDifferentResidentialAddress === 'true' ? formValues.ExtensionResidentialAddress.Postcode : formValues.ExtensionPostalAddress.Postcode,
    Country: formValues.HasDifferentResidentialAddress === 'true' ? (formValues.ExtensionResidentialAddress.State ? formValues.ExtensionResidentialAddress.Country : '') : (formValues.ExtensionPostalAddress.State ? formValues.ExtensionPostalAddress.Country : ''),
    // postal address
    LineOneTwo: formValues.ExtensionPostalAddress.LineOne,
    LineTwoTwo: formValues.ExtensionPostalAddress.LineTwo,
    PostalAddress: formValues.ExtensionPostalAddress.Address,
    PostcodeTwo: formValues.ExtensionPostalAddress.Postcode,
    SuburbTwo: formValues.ExtensionPostalAddress.Suburb,
    StateTwo: formValues.ExtensionPostalAddress.State,
    CountryTwo: formValues.ExtensionPostalAddress.State ? formValues.ExtensionPostalAddress.Country : '',

    ContactNumber: formValues.ExtensionContactNumber.ContactNumber,
    NumberType: formValues.ExtensionContactNumber.NumberType,
    SecondaryContactNumber: formValues.ExtensionContactNumber.SecondaryContactNumber,
    NumberTypeTwo: formValues.ExtensionContactNumber.SecondaryContactNumber ? formValues.ExtensionContactNumber.SecondaryNumberType : '',
    YourEmailAddressOptional: formValues.Email, // pending
    DocumentElectronically: formValues.receiveDocs === 'true' ? 'Yes' : 'No',
    // send copy to
    EMAIL_TO: formValues.EMAIL_TO === 'true' ? formValues.Email : '',

    DDThree: formValues.DateToPay ? (`0${formValues.DateToPay.getDate()}`).slice(-2) : '',
    MMThree: formValues.DateToPay ? ((`0${formValues.DateToPay.getMonth() + 1}`).slice(-2)) : '',
    YYYYThree: formValues.DateToPay ? formValues.DateToPay.getFullYear().toString() : '',

    ObligationNumberCaseNumberOrWarrantNumber: selectedObligationsSelfInclude,
    YesOrNoTwo: formValues.ExceptionalCircumstances === 'true' ? 'Yes' : 'No', // circumstances exceptional

    ProvideDetailsForAnyCircumstancesYouWouldLikeToBeConsideredForInThisApplication: formValues.DetailsForCircumstances,
    // Step 7
    NumberOfAttachments: totalNumberOfAttachments.toString(),

    ApplicantsSignature: formValues.declaration ? 'I agree to the statements' : '',
    DocumentDescriptions: descriptionOfAttachments,
    DdTwo: DATE.toString(),
    MmTwo: MONTH.toString(),
    YyyyTwo: YEAR.toString(),

    // additional OB pdf page
    OBLIGATIONS_TO_INCLUDE: additonalPdfWithObligations,
    // attachments
    ATTACHMENTS: remoteAttachmentNames,
    // Footer information

    FooterSubmissionNo1: submissionNumber,
    FooterFormType1: FORM_TYPE,
    FooterObligationNo1: formValues.OBLIGATION_NUMBER,
    FooterSubmittedTime1: SUBMITTED_TIME,

    FooterSubmissionNo2: submissionNumber,
    FooterFormType2: FORM_TYPE,
    FooterObligationNo2: formValues.OBLIGATION_NUMBER,
    FooterSubmittedTime2: SUBMITTED_TIME,

    FooterSubmissionNo3: submissionNumber,
    FooterFormType3: FORM_TYPE,
    FooterObligationNo3: formValues.OBLIGATION_NUMBER,
    FooterSubmittedTime3: SUBMITTED_TIME,

    FooterSubmissionNo4: submissionNumber,
    FooterFormType4: FORM_TYPE,
    FooterObligationNo4: formValues.OBLIGATION_NUMBER,
    FooterSubmittedTime4: SUBMITTED_TIME,

    FooterSubmissionNo5: submissionNumber,
    FooterFormType5: FORM_TYPE,
    FooterObligationNo5: formValues.OBLIGATION_NUMBER,
    FooterSubmittedTime5: SUBMITTED_TIME,

    FooterSubmissionNo6: submissionNumber,
    FooterFormType6: FORM_TYPE,
    FooterObligationNo6: formValues.OBLIGATION_NUMBER,
    FooterSubmittedTime6: SUBMITTED_TIME,

    FooterSubmissionNo7: submissionNumber,
    FooterFormType7: FORM_TYPE,
    FooterObligationNo7: formValues.OBLIGATION_NUMBER,
    FooterSubmittedTime7: SUBMITTED_TIME,
  };

  const excludeKeysFromForm: string[] = [
    // fields from iExtensionFormValues
    'submitted',
    'OffenceDateRequired',
    'HearingDateRequired',
    'LicenceRequired',
    'RegistrationRequired',
    'DOBRequired',
    'OFFENCE_DATE',
    'HEARING_DATE',
    'DRIVER_LICENCE',
    'PartialFormID',
    'ID',
    'FormData',
    'Obligations',
    'Attachments',
    'DebtorID',
    'FormTypeID',
    'IsSubscribedEM',
    'IsSubscribedSMS',
    'EMRemeinderSent',
    'SMSRemeinderSent',
    'CreateDate',
    'ExpiryDate',
    'SeriousObligation',
    'DDD',
    'ESI',
    'MarineOffence',
    'submissionNo',
    'DOB',
    'LicenceState',
    'ExtensionResidentialAddress',
    'HasDifferentResidentialAddress',
    'SummonsAddress',
    'Email',
    'NoEmail',
    'declaration',
    'SaveYesNo',
    'SaveOptions',
    'saveEmail',
    'saveMobile',
    'a',
    'VEHICLE_REGISTRATION',
    'UserType',
    'NoDriverLicence',
    'CompanyAddress',
    'CompanyPostalAddress',
    'HasDifferentCompanyAddress',
    'DebtorType',
    'RepresentativeGivenName',
    'RepresentativeFamilyName',
    'RepresentativeRelationshipToVictim',
    'RepresentativeCompanyName',
    'RepresentativeCompanyPosition',
    'RepresentativePostalAddress',
    'RepresentativeEmailAddress',
    'RepresentativeRequestsEmailCopyBool',
    'ExtensionContactNumber',
    'RepresentativeAllowsPhoneCommunicationBool',
    'RepresentativePreferredContactDayTime',
    // Extension excluding UI fields
    'OtherReportNameFieldErrorHandle',
    'OtherSupportingFilesDescription',
    'OtherSupportingFilesProvider',
    'OtherSupportingAttachments',
    'OtherSupportingDocNameField',
    'ReportUploadFileSectionError',
    'ReportNameFieldErrorHandle',
    'ReportNameField',
    'SupportingFilesDescription',
    'SupportingFilesProvider',
    'SupportingAttachments',
    'SelectedObligations',
    'AdditionalFinesToInclude',
    'RegisteredFinesToInclude',
    'AdditionalFinesType',
    'OffenceCode',
    'Status',
    'TicketType',
    'ObligationStatus',
    'infringementFineArray',
    'SelectedObligationsStep9',
    'ExceptionalCircumstances',
    'receiveDocs',
    'ExtensionPostalAddress',
    'NoResidentialAddress',
    'AuthorisedObligation',
    'EligibleObligations',
    'SelectedObNums',
    'submissionError',
    'EmailWarning',
    'ExtensionContactNumberWarning',
    'ExtensionContactNumberWarningSecond',
  ];
  excludeKeysFromForm.forEach((value: string) => {
    delete submitObject[value];
  });
  return submitObject;
};

export const ExtensionSchema = Yup.object().shape({
  saveEmail: Yup.string().email(INVALID_EMAIL).required(INVALID_NUMERIC_FORMAT),
  saveMobile: Yup.string()
    .min(10, INVALID_MOBILE_NUMBER_FORMAT)
    .max(10, INVALID_PHONE_NUMBER_LENGTH)
    .matches(CONTACT_NUMBER_REGEX, INVALID_PHONE_NUMBER)
    .required(INVALID_PHONE_NUMBER),
  SaveYesNo: Yup.string().required(INVALID_YESNO_FORMAT),
  SaveOptions: Yup.string().when('SaveYesNo', {
    is: 'true',
    then: Yup.string().required(INVALID_NUMERIC_FORMAT),
  }),
  OBLIGATION_NUMBER: Yup.string().matches(OBLIGATION_REGEX, INVALID_OBLIGATION_NUMBER).required(INVALID_NUMERIC_FORMAT),
  OFFENCE_DATE: Yup.date().required(EMPTY_DATE).nullable().max(new Date(), INVALID_FUTURE_DATE),
  HEARING_DATE: Yup.date().required(EMPTY_DATE).nullable(),
  DRIVER_LICENCE: Yup.string()
    .required(INVALID_NUMERIC_FORMAT)
    .matches(/^[a-zA-Z0-9 ]*$/, INVALID_LICENCE_FORMAT),
  // Step 5
  DateToPay: Yup.date().required(EMPTY_DATE).nullable().min(new Date(), 'Please enter a valid date.')
    .max(new Date(today.setMonth(today.getMonth() + 3)), 'Please enter a valid date.'),
  VEHICLE_REGISTRATION: Yup.string().matches(VEHICLE_REGISTRATION_REGEX, INVALID_VEHICLE_REGISTRATION_NUMBER).required(INVALID_VEHICLE_REGISTRATION_NUMBER),
  TitleMrMrsMsMissOther: Yup.string().required(INVALID_YESNO_FORMAT),
  DOB: Yup.date().required(EMPTY_DATE).nullable().max(new Date(), INVALID_FUTURE_DATE),
  FamilyName: Yup.string().matches(NAME_FIELDS_NEW_REGEX, INVALID_NAME_FORMAT).required(INVALID_NUMERIC_FORMAT),
  GivenNames: Yup.string().matches(NAME_FIELDS_NEW_REGEX, INVALID_NAME_FORMAT).required(INVALID_NUMERIC_FORMAT),
  StatecountryOfIssue: Yup.string(),
  LicenceState: Yup.string().required(INVALID_YESNO_FORMAT),
  NoDriverLicence: Yup.boolean(),
  ExtensionResidentialAddress: Yup.object().shape({
    SearchText: Yup.string(),
    LineOne: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG).required(INVALID_NUMERIC_FORMAT),
    LineTwo: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG),
    Suburb: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG).required(INVALID_NUMERIC_FORMAT),
    Postcode: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG).required(INVALID_NUMERIC_FORMAT),
    Country: Yup.string().required(INVALID_NUMERIC_FORMAT),
    State: Yup.string().when('Country', {
      is: 'Australia',
      then: Yup.string().required(INVALID_NUMERIC_FORMAT),
    }),
  }),
  ExtensionPostalAddress: Yup.object().shape({
    SearchText: Yup.string(),
    LineOne: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG).required(INVALID_NUMERIC_FORMAT),
    LineTwo: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG),
    Suburb: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG).required(INVALID_NUMERIC_FORMAT),
    Postcode: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG).required(INVALID_NUMERIC_FORMAT),
    Country: Yup.string().required(INVALID_NUMERIC_FORMAT),
    State: Yup.string().when('Country', {
      is: 'Australia',
      then: Yup.string().required(INVALID_NUMERIC_FORMAT),
    }),
  }),
  Email: Yup.string().email(INVALID_EMAIL).required(INVALID_NUMERIC_FORMAT),
  NoEmail: Yup.boolean(),
  EMAIL_TO: Yup.string().required(INVALID_YESNO_FORMAT).nullable(),
  receiveDocs: Yup.string().required(INVALID_YESNO_FORMAT).nullable(),
  HasDifferentResidentialAddress: Yup.string().required(INVALID_YESNO_FORMAT).nullable(),
  // step 7
  DetailsForCircumstances: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG).required(INVALID_NUMERIC_FORMAT),
  ExceptionalCircumstances: Yup.string().required(INVALID_YESNO_FORMAT),
  AdditionalFinesType: Yup.string().required(INVALID_YESNO_FORMAT),
  RegisteredFinesToInclude: Yup.string().required(INVALID_YESNO_FORMAT),
  InfringementFinesToInclude: Yup.string().required(INVALID_YESNO_FORMAT),
  // step 12 13
  OtherSupportingFilesDescription: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG),
  OtherReportNameFieldErrorHandle: Yup.boolean().oneOf([false], INVALID_FILE_SIZE),
  OtherReportNameFileUploadErrorHandle: Yup.boolean().oneOf([false], FILE_UPLOAD_FAIL),
  declaration: Yup.boolean().oneOf([true], MISSING_DECLARATION_AGREEMENT),
  ExtensionContactNumber: Yup.object().shape({
    ContactNumber: Yup.string().max(15, INVALID_PHONE_NUMBER_LENGTH_15).matches(CONTACT_NUMBER_REGEX, INVALID_PHONE_NUMBER).required(INVALID_PHONE_NUMBER),
    NumberType: Yup.string().required(INVALID_YESNO_FORMAT),
    SecondaryContactNumber: Yup.string().max(15, INVALID_PHONE_NUMBER_LENGTH_15).matches(CONTACT_NUMBER_REGEX, INVALID_PHONE_NUMBER),
    SecondaryNumberType: Yup.string(),
  }),
});

const { EXTENSION } = FormType;

export const extensionMetaData: iFormMetaData = {
  pagesSegments: {
    step0: {
      progressStep: ProgressStep.START,
      validationKeys: (values: FormikValues) => [],
    },
    step1: {
      progressStep: ProgressStep.START,
      validationKeys: (values: FormikValues) => keys(values, EXTENSION).page1,
    },
    step2: {
      progressStep: ProgressStep.START,
      validationKeys: (values: FormikValues) => keys(values, EXTENSION).page2,
    },
    step3: {
      progressStep: ProgressStep.START,
      validationKeys: (values: FormikValues) => keys(values, EXTENSION).page3,
    },
    step4: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, EXTENSION).page4,
    },
    step5: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, EXTENSION).page5,
    },
    step6: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, EXTENSION).page6,
    },
    step7: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, EXTENSION).page7,
    },
    step8: {
      progressStep: ProgressStep.CHECK_CONFIRM,
      validationKeys: (values: FormikValues) => keys(values, EXTENSION).page8,
    },
    step9: {
      progressStep: ProgressStep.CHECK_CONFIRM,
      validationKeys: (values: FormikValues) => keys(values, EXTENSION).page9,
    },
    step10: {
      progressStep: ProgressStep.DONE,
      validationKeys: (values: FormikValues) => [],
    },
    step11: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, EXTENSION).page11,
    },
    step12: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, EXTENSION).page12,
    },
    step13: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, EXTENSION).page13,
    },
    step14: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, EXTENSION).page14,
    },
    step15: {
      progressStep: ProgressStep.START,
      validationKeys: (values: FormikValues) => keys(values, EXTENSION).page15,
    },
    step16: {
      progressStep: ProgressStep.DONE,
      validationKeys: (values: FormikValues) => [],
    },
  },
};

export const getSummaryScreen = (values: iExtensionFormValues): iSummary[] => {
  const checkFines = values.SelectedObligationsStep9.map((fine) => {
    if (fine.checked) return fine.number.toString();
    return '';
  })
    .filter(Boolean)
    .join('; ');

  const checkOptSupportingDoc = values.OtherSupportingAttachments.map((attachment) => displayFileDetails(attachment))
    .filter(Boolean)
    .join('\n');

  const page4 = {
    title: 'Your fines',
    editLink: '/step4',
    fields: [
      [
        {
          title: 'Fines to include in application',
          value: checkFines !== '' ? `${checkFines}; ${values.AuthorisedObligation.Number}` : values.AuthorisedObligation.Number,
        },
      ],
    ],
  };
  const page5 = {
    title: 'Extension date',
    editLink: '/step5',
    fields: [
      [
        {
          title: 'When will you be able to pay the total outstanding amount?',
          value: values.DateToPay ? `${values.DateToPay?.getDate()}/${values.DateToPay?.getMonth() + 1}/${values.DateToPay?.getFullYear()}` : 'n/a',
        },
      ],
    ],
  };
  const page6 = {
    title: 'Your details',
    editLink: '/step6',
    fields: [
      [{ title: 'Title', value: values.TitleMrMrsMsMissOther }],
      [{ title: 'Given name(s)', value: values.GivenNames }],
      [{ title: 'Family name', value: values.FamilyName }],
      [{ title: 'Date of birth', value: values.DOB ? `${values.DOB.getDate()}/${values.DOB.getMonth() + 1}/${values.DOB.getFullYear()}` : 'n/a' }],
      [
        values.NoDriverLicence
          ? { title: 'Driver licence number', value: 'n/a' }
          : { title: 'Driver licence number', value: values.DRIVER_LICENCE ? values.DRIVER_LICENCE : 'n/a' },
      ],
      [
        values.NoDriverLicence
          ? { title: 'Place of issue', value: 'n/a' }
          : {
              title: 'Place of issue',
              value:
                values.StatecountryOfIssue === 'Australia' ? (values.LicenceState ? values.LicenceState : 'n/a') : values.StatecountryOfIssue ? values.StatecountryOfIssue : 'n/a',
            },
      ],
      [
        {
          title: 'Postal address',
          value: `${Object.entries(values.ExtensionPostalAddress)
            .map((entry) => joinAddressFields(entry))
            .filter(Boolean)
            .join(', ')}`,
        },
      ],
      values.HasDifferentResidentialAddress === 'false'
      ? [{ title: 'Is your residential address different to your postal address?', value: 'No' }]
      : [
          {
            title: 'Residential address',
            value: `${Object.entries(values.ExtensionResidentialAddress)
              .map((entry) => joinAddressFields(entry))
              .filter(Boolean)
              .join(', ')}`,
          },
        ],
        [{ title: 'Contact phone number', value: values.ExtensionContactNumber.ContactNumber }],
        [{ title: 'Number type', value: values.ExtensionContactNumber.NumberType }],
        [
          {
            title: 'Secondary contact number',
            value: values.ExtensionContactNumber.SecondaryContactNumber ? values.ExtensionContactNumber.SecondaryContactNumber : 'n/a',
          },
        ],
        [{ title: 'Secondary number type', value: values.ExtensionContactNumber.SecondaryContactNumber ? values.ExtensionContactNumber.SecondaryNumberType : 'n/a' }],
        [{ title: 'Email', value: values.Email ? values.Email : 'n/a' }],
      [{ title: 'Would you like to receive a copy of the completed application at the email address provided?', value: values.EMAIL_TO === 'true' ? 'Yes' : 'No' }],
      [{ title: 'I consent to receive documentation electronically', value: values.receiveDocs === 'true' ? 'Yes' : 'No' }],
    ],
  };
  const page7 = {
    title: 'Your financial details',
    editLink: '/step7',
    fields: [
      [
        {
          title: 'Do you have any exceptional financial circumstances you would like to let us know about?',
          value: values.ExceptionalCircumstances === 'true' ? 'Yes' : 'No',
        },
      ],
      values.DetailsForCircumstances ? [
        {
          title: 'Provide details for any circumstances you would like to be considered for in this application.',
          value: values.DetailsForCircumstances ? values.DetailsForCircumstances.toString() : '',
        },
      ] : [],
       checkOptSupportingDoc ? [
          {
          title: 'Supporting documents',
          value: checkOptSupportingDoc !== '' ? checkOptSupportingDoc : 'n/a',
          },
        ] : [],
    ],
  };

  const pagesExtensionSummary: iSummary[] = [
    page4,
    page5,
    page6,
    page7,
  ];
  const summarySections: iSummary[] = pagesExtensionSummary;
  return summarySections;
};
